export { default as Accept } from './accept'
export { default as Administration } from './administration'
export { default as AspectRatio } from './aspectRatio'
export { default as Basket } from './basket'
export { default as Bell } from './bell'
export { default as Bubble } from './bubble'
export { default as Delete } from './delete'
export { default as Download } from './download'
export { default as Edit } from './edit'
export { default as EmptyFolder } from './emptyFolder'
export { default as Filters } from './filters'
export { default as HiddenMenu } from './hiddenMenu'
export { default as HideStartPage } from './hideStartPage'
export { default as History } from './history'
export { default as Logout } from './logout'
export { default as Multiple } from './multiple'
export { default as NavigateDown } from './navigateDown'
export { default as NavigateNext } from './navigateNext'
export { default as NavigatePrev } from './navigatePrev'
export { default as Node } from './node'
export { default as Picture } from './picture'
export { default as Plus } from './plus'
export { default as Reject } from './reject'
export { default as Send } from './send'
export { default as ShowStartPage } from './showStartPage'
export { default as System } from './system'
export { default as Tags } from './tags'
export { default as TargetMedia } from './targetmedia'
export { default as Upload } from './upload'
export { default as User } from './user'
export { default as Warning } from './warning'
export { default as Exit } from './exit'



// WEBPACK FOOTER //
// ./src/components/Icons/index.js